//this list must match the one in app/javascript/packs/styles/reactmd.scss, Base palette colors
const main_colors = {
    //grey scale
    white: '#FFFFFF',
    snow: '#FBFBFB',
    anti_flash_white: '#EBEDF2',
    ash_grey: '#AFB5B8',
    grey: '#808080',
    davys_grey: '#5D5D5D',
    charcoal:'#37474F',
    black: '#000',
    //blues
    alice_blue: '#F0F9FE',
    light_sky_blue: '#81D4FA',
    cyan: '#26C6DA',
    rich_electric_blue: '#039BE5',
    ocean_boat_blue: '#0277BD',
    toolbox: '#5D6BC0',
    //green
    dark_sea_green: '#81C784',
    green_dark: '#12A73A',
    //yellow
    deep_saffron: '#FFA726',
    //red
    carmine:'#EF5350',
    red_dark: '#B71C1C',
    //magenta
    magenta: '#BA68C8',
}
const chart_colors = [
    main_colors.cyan,
    main_colors.deep_saffron,
    main_colors.toolbox,
    main_colors.dark_sea_green,
    main_colors.magenta,
    main_colors.davys_grey,
]

const data_coverage_colors = [
    main_colors.deep_saffron,
    main_colors.toolbox,
    main_colors.light_sky_blue,
    main_colors.dark_sea_green,
    main_colors.carmine,
    main_colors.rich_electric_blue,
]
export { main_colors, chart_colors, data_coverage_colors}